<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:items="modelos"
			:headers="colunas"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item.titulo="{ item }">
				<texto-tooltip :texto="item.nome" :tamanho-maximo="nomeTamanhoMaximo"></texto-tooltip>
			</template>
			<template #item.tipoDocumento="{ item }">
				<texto-tooltip
					:texto="item.tipoDocumento.nome"
					:tamanho-maximo="tipoDocumentoTamanhoMaximo"
				></texto-tooltip>
			</template>
			<template #item.dataCadastro="{ item }">
				<span> {{ item.dataCadastro | formatDataFilter }} </span>
			</template>
			<template #item.situacao="{ item }">
				<span> {{ filtrarSituacao(item.situacao) }} </span>
			</template>
			<template #item.acoes="{ item }">
				<modelo-documento-listagem-botoes-acoes
					:id-modelo="item.id"
					@abrir-modal-editar="editarModelo(item.id)"
					@abrir-modal-excluir="abrirModalExcluirModeloDocumento(item.id)"
				>
				</modelo-documento-listagem-botoes-acoes>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
		<template-listagem-vazia :total-itens="totalItens" :textos="textoListagemVazia"></template-listagem-vazia>

		<editar-modelo-documento
			:exibir="exibirModalEditarModeloDocumento"
			@fechar-modal="abrirModalEditarModeloDocumento"
			@resetar-page="resetarPage"
		></editar-modelo-documento>
		<modal-confirmacao
			id="excluir"
			:exibir="exibirModalExclusaoItem"
			:mensagem="mensagemExclusaoItem"
			@fechar-modal="abrirModalExcluirModeloDocumento"
			@confirmar="confirmarExcluirModelo"
			:subtituloModal="subtituloModalExclusao"
			:tituloModal="tituloModalexclusao"
		></modal-confirmacao>
	</div>
</template>
<script>
import situacaoFilter from '@/views/filters/situacao-filter'
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import ModeloDocumentoListagemBotoesAcoes from '@/views/pages/configuracao/modelo-documento/listagem/botoes-acoes/ModeloDocumentoListagemBotoesAcoes.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import { actionTypes, situacoes } from '@/core/constants'
import mutationTypes from '@/core/constants/mutation-types'
import EditarModeloDocumento from '@/views/pages/configuracao/modelo-documento/listagem/editar-modelo/EditarModeloDocumento.vue'

export default {
	name: 'modelo-documento-listagem',
	components: {
		TextoTooltip,
		ModeloDocumentoListagemBotoesAcoes,
		TemplateListagemVazia,
		EditarModeloDocumento,
	},
	mixins: [tabelaMixin],
	props: {
		modelos: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Titulo', 'titulo', '25%'),
				new TabelaColunaUtils('Tipo', 'tipoDocumento', '25%'),
				new TabelaColunaUtils('Criação', 'dataCadastro', '15%'),
				new TabelaColunaUtils('Situação', 'situacao', '15%'),
				new TabelaColunaUtils('Ações', 'acoes', '5%'),
			],
			textoListagemVazia: {
				titulo: 'Nenhum modelo de documento foi encontrado',
			},
			paginacaoInterna: this.paginacao,
			nomeTamanhoMaximo: 50,
			tipoDocumentoTamanhoMaximo: 30,
			exibirModalEditarModeloDocumento: false,
			exibirModalExclusaoItem: false,
			mensagemExclusaoItem: 'O modelo excluído não poderá ser recuperado!',
			subtituloModalExclusao: 'Deseja realmente excluir?',
			tituloModalexclusao: 'Excluir',
			idModeloParaExcluir: null,
		}
	},
	computed: {},
	methods: {
		filtrarSituacao(situacao) {
			return situacaoFilter(situacao, situacoes.MODELO_DOCUMENTO)
		},
		async resetarPage() {
			await this.$emit('resetar-page')
			await this.$emit('recarregar-listagem-modelo-documento')
		},
		async editarModelo(idModelo) {
			const modelo = await this.$store.dispatch(actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.BUSCAR_MODELO, idModelo)
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.SET_INFORMACOES_MODELO, modelo)
			this.abrirModalEditarModeloDocumento()
		},
		async confirmarExcluirModelo() {
			await this.$store.dispatch(
				actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.EXCLUIR_MODELO,
				this.idModeloParaExcluir,
			)

			this.mostrarNotificacaoSucesso('Modelo excluído com sucesso.')
			this.abrirModalExcluirModeloDocumento()
			await this.resetarPage()
		},
		abrirModalEditarModeloDocumento() {
			this.exibirModalEditarModeloDocumento = !this.exibirModalEditarModeloDocumento
		},
		abrirModalExcluirModeloDocumento(idModelo) {
			this.idModeloParaExcluir = idModelo
			this.exibirModalExclusaoItem = !this.exibirModalExclusaoItem
		},
	},
}
</script>
<style lang="stylus" scoped></style>
